const REVIEWERROUTES = {
  GETREVIEWERLIST: "masters/user/basic/nameandid/Reviewer",
  GETCLIENTLIST: (USER_ID) =>
    `clients/client/basic/reviewer/${USER_ID}/advanced/all`,
};

export default REVIEWERROUTES;
